import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
const RenderedText = ({ prefixCls, children, onContentChange, hidden, className, isFlat, rangeTarget }) => {
    const renderedValueRef = useRef(null);
    const [content, setContent] = useState(null);
    const selfPrefixCls = `${prefixCls}-rendered-value`;
    const style = useMemo(() => isFlat ? {
        width: 'auto',
        maxWidth: 'none',
    } : undefined, [isFlat]);
    useLayoutEffect(() => {
        if (onContentChange) {
            const { current } = renderedValueRef;
            if (current) {
                const { textContent } = current;
                if (textContent !== null && textContent !== content) {
                    setContent(textContent);
                    onContentChange(textContent, current.scrollWidth, rangeTarget);
                }
            }
        }
    }, [onContentChange, renderedValueRef, content, children, rangeTarget]);
    return (React.createElement("span", { key: "renderedText", className: classNames(selfPrefixCls, className), hidden: hidden, style: style },
        React.createElement("span", { className: `${selfPrefixCls}-inner`, ref: renderedValueRef }, children)));
};
RenderedText.displayName = 'RenderedText';
export default RenderedText;
